export default function NotFoundIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      version="1.1"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      width="150"
      height="150"
      x="0"
      y="0"
      viewBox="0 0 512 512"
      style={{ enableBackground: "new 0 0 512 512" }}
      xmlSpace="preserve"
      className=""
    >
      <g>
        <path
          fill="#16a34a"
          d="M504.398 45.55v286.325c0 20.957-16.992 37.95-37.949 37.95H45.547c-20.957 0-37.942-16.993-37.942-37.95V45.551C7.605 24.594 24.59 7.6 45.547 7.6h420.902c20.957 0 37.95 16.993 37.95 37.95zm0 0"
          opacity="1"
          //   data-original="#20a5d3"
          className=""
        ></path>
        <path
          fill="#16a34a"
          d="M504.398 45.55v286.325c0 20.957-16.992 37.95-37.949 37.95H201.75L294.914 7.601H466.45c20.957 0 37.95 16.992 37.95 37.949zm0 0"
          opacity="1"
          //   data-original="#1090b2"
          className=""
        ></path>
        <path
          fill="#1e293b"
          d="M504.398 306.527v25.348c0 20.957-16.992 37.95-37.949 37.95H45.547c-20.957 0-37.942-16.993-37.942-37.95v-25.348zm0 0"
          opacity="1"
          //   data-original="#42444c"
          className=""
        ></path>
        <path
          fill="#1e293b"
          d="M355.434 448.906H156.563l14.57-40.554 13.84-38.528h142.05l13.84 38.528zm0 0"
          opacity="1"
          //   data-original="#42444c"
          className=""
        ></path>
        <path
          fill="#0f172a"
          d="M340.863 408.352h-169.73l13.84-38.528h142.05zm0 0"
          opacity="1"
          //   data-original="#2c2e35"
          className=""
        ></path>
        <path
          d="M466.45 0H45.55C20.435 0 0 20.434 0 45.55v45.462c0 4.199 3.402 7.601 7.605 7.601a7.6 7.6 0 0 0 7.602-7.601V45.55c0-16.73 13.613-30.344 30.344-30.344h420.898c16.73 0 30.344 13.613 30.344 30.344v253.375h-69.445c-4.2 0-7.602 3.406-7.602 7.605s3.402 7.606 7.602 7.606h69.445v17.742c0 16.73-13.613 30.344-30.344 30.344H45.551c-16.73 0-30.344-13.614-30.344-30.344v-17.742H402c4.2 0 7.602-3.407 7.602-7.606s-3.403-7.605-7.602-7.605H15.207V116.359a7.604 7.604 0 1 0-15.207 0v215.52c0 25.117 20.434 45.55 45.55 45.55h128.614l-22.945 63.876H98.75c-4.203 0-7.605 3.402-7.605 7.601s3.402 7.606 7.605 7.606h314.5a7.604 7.604 0 1 0 0-15.207h-52.469l-22.945-63.875h128.613c25.117 0 45.551-20.434 45.551-45.551V45.55C512 20.434 491.566 0 466.45 0zM344.62 441.305H167.38l22.945-63.875h131.352zm0 0"
          fill="#020617"
          opacity="1"
          //   data-original="#000000"
          className=""
        ></path>
        <g fill="#e6e6e6">
          <path
            d="M171.746 118.574c0-6.765-7.258-10.922-12.46-10.922-4.845 0-8.985 2.57-11.395 7.125l-47.496 93.649c-1.036 1.668-1.56 3.66-1.56 5.926 0 6.43 4.333 10.921 10.536 10.921h43.617v22.032c0 5.996 5.32 10.343 12.657 10.343 7.332 0 12.656-4.351 12.656-10.343v-22.032h5.648c4.996 0 10.344-4.93 10.344-12.27 0-7.112-4.352-12.273-10.344-12.273h-5.648v-27.812c0-5.977-5.207-10.148-12.656-10.148-7.454 0-12.657 4.171-12.657 10.148v27.812h-21.383l38.82-77.273c.915-1.578 1.321-3.094 1.321-4.883zM302.285 212.234v-58.007c0-29.598-16.836-46.575-46.187-46.575-29.23 0-45.996 16.977-45.996 46.575v58.007c0 29.598 16.765 46.57 45.996 46.57 29.351 0 46.187-16.972 46.187-46.57zm-66.87 0v-58.007c0-15.344 6.765-22.805 20.683-22.805 14.047 0 20.875 7.46 20.875 22.805v58.007c0 15.344-6.828 22.801-20.875 22.801-13.918 0-20.684-7.46-20.684-22.8zM390.617 118.574c0-6.765-7.258-10.922-12.465-10.922-4.843 0-8.98 2.57-11.39 7.125l-47.496 93.649c-1.036 1.668-1.559 3.66-1.559 5.926 0 6.43 4.332 10.921 10.535 10.921h43.617v22.032c0 5.996 5.32 10.343 12.657 10.343 7.332 0 12.656-4.351 12.656-10.343v-22.032h5.648c4.996 0 10.344-4.93 10.344-12.27 0-7.112-4.351-12.273-10.344-12.273h-5.648v-27.812c0-5.977-5.207-10.148-12.656-10.148-7.454 0-12.657 4.171-12.657 10.148v27.812H350.48l38.813-77.273c.914-1.578 1.324-3.094 1.324-4.883zm0 0"
            fill="#f1f5f9"
            opacity="1"
            // data-original="#e6e6e6"
            className=""
          ></path>
        </g>
      </g>
    </svg>
  );
}
